import { render, staticRenderFns } from "./CreateMetaLeadChannel.vue?vue&type=template&id=01627465&scoped=true"
import script from "./CreateMetaLeadChannel.vue?vue&type=script&lang=js"
export * from "./CreateMetaLeadChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateMetaLeadChannel.vue?vue&type=style&index=0&id=01627465&prod&lang=scss&scoped=true"
import style1 from "./CreateMetaLeadChannel.vue?vue&type=style&index=1&id=01627465&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01627465",
  null
  
)

export default component.exports